import Vue from "vue";
import { Toast } from "vant";
interface teacherEntryDateP {
  name: string; // 老师名称
  sex: string; //性别  1：男，2：女
  national: string; //国籍代码
  mobile: string; //手机号
  edu: string; //最高学历
  school: string; //毕业院校
  major: string; //专业信息
  experience: string; //教学经验
  join_time: string; //入职时间
  urgent_nation: string; //紧急联系人电话国籍代码
  urgent_mobile: string; //紧急联系人电话
  skills: string; //专业功底
  idcard: string; //身份证号
  bank_name: string; //本人【工资】卡所在银行
  bank_mobile_nation: string; //银行预留手机号国籍代码
  bank_mobile: string; //本人【工资】卡银行预留手机号
  bank_number: string; //本人【工资】卡银行卡号
  edu_file: string; //学历图片
  idcard_file: string; //身份证图片
  isBankNum: string;
  head_pic: string;
  all_specialty: string[]; //所有授权科目
  specialty: string[] | string; //授权科目
}
import { teachetEntrySaveTeacherInfo } from "@/api/teacher/teacherApplicationFrom";
export default {
  namespaced: true,
  state() {
    return {
      // 个人信息
      currentEntryPage: 0
    };
  },
  mutations: {},
  actions: {
    async apiSaveTeacherInfo(store: any, param: {}) {
      let dataInfo = { ...param };
      let res = await teachetEntrySaveTeacherInfo(dataInfo);
      if (res.data.status === 0) {
        // Toast(res.data.msg);
        console.log();
      } else {
        Toast(res.data.msg);
      }
    }
  }
};
